import React, { FunctionComponent, useMemo } from "react";

import { ButtonBackgroundColor, ButtonThemeVariant, IconButton, IconColor } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { DropdownAction, DropdownItemBaseProps } from "../../types";
import { DropdownIconText } from "../DropdownIconText";
import { DropdownItemWrapper } from "../DropdownItemWrapper";

const classNames = bemClassNames("dropdown-multibutton-item");

const renderActionButtons = (actions: ReadonlyArray<DropdownAction>) => {
    return actions
        ?.filter((item) => item?.icon && item?.onClick)
        .map(
            (item) => <IconButton
                key={item.title}
                variant={ButtonThemeVariant.dropdown}
                iconCode={item.icon!}
                onClick={(e) => item.onClick?.(e, item.type)}
                title={item.title}
                color={IconColor.default}
                backgroundColor={ButtonBackgroundColor.inherit}
            />,
        );
};

export type DropdownMultiButtonsItemProps = {
    /** Pole akcí pro další tlačítka */
    actions: readonly DropdownAction[];
} & DropdownItemBaseProps;

/**
 * Tlačítko DropDown, které umožní standartně zorbazit ikonu a text plus umožnuje zobrazit dodatečná tlačítka na pravé straně
 * Tlačítka na pravé straně zobrazují pouze ikonu.
 */
export const DropdownMultiButtonsItem: FunctionComponent<DropdownMultiButtonsItemProps> = ({
    clickAction,
    actions,
    ...restProps
}) => {
    const actionButtons = useMemo(() => renderActionButtons(actions), [actions]);
    const clickEvent = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => clickAction?.onClick?.(e, "main");

    return (
        <DropdownItemWrapper {...restProps}>
            <div className={classNames()}>
                <div className={classNames("title", { disabled: clickAction?.disabled })} onClick={clickEvent} title={clickAction?.title}>
                    <DropdownIconText iconCode={clickAction?.icon} value={clickAction?.text} disabled={clickAction?.disabled} {...restProps} />
                </div>
                {actions?.length > 0 && <div className={classNames("icons")}>
                    {actionButtons}
                </div>}
            </div>
        </DropdownItemWrapper>);
};
